export default "__VITE_ASSET__CYGTGtHs__"